import { CustomRegistry } from "@nemuru-eng/js-api-client";

const FilteredRegistries = [
  CustomRegistry.DEFAULT,
  CustomRegistry.CAIXABANK,
  CustomRegistry.FACILITEA,
  CustomRegistry.TESLA,
  CustomRegistry.COCHESNET,
  CustomRegistry.UPF,
  CustomRegistry.ASTARA,
  CustomRegistry.VAILLANT,
  CustomRegistry.TECHNOLOGICAL_PLATFORM,
];

export const RegistryMapper = {
  hydrate(registry) {
    if (!FilteredRegistries.includes(registry)) {
      return CustomRegistry.DEFAULT;
    }
    return registry;
  },
};
